module.exports = __webpack_public_path__ + "img/alignment-no.ee9f898b.svg";